import { useHandbook } from 'components/Handbook2_0/hooks'
import { isEqual } from 'lodash'
import { useSelector } from 'react-redux'

import { RootState } from 'types'
import { getHandbookPassword } from './useHandbookPasswords'

export const useArticlePassword = (key: string) => {
  const handbook = useHandbook()
  const folderPassword = getHandbookPassword(handbook?.key)
  const articlePassword = useSelector(({ articlePassword }: RootState) => articlePassword[key], isEqual)
  return articlePassword || folderPassword || undefined
}
